<template>
  <li @click="addToBasket($event)" :id="'product_' + product.id">
    <a
      :class="{
        tl_add: selected,
        tl_none:
          product.is_stopped || category.work_time.is_working_now === false,
        tl_small_img:
          product.images.length > 0 && imagesStyle === IMAGES_SQUARE_MINIATURE,
      }"
    >
      <div class="tl_img">
        <!--if has image-->
        <template v-if="product.images.length > 0">
          <div
            v-lazyloadImage
            class="placeholder"
            :style="{ paddingTop: placeholderPadding }"
          >
            <div v-if="product.images.length > 1 && basketPhoto" class="product-image-multiple">
            </div>
            <template v-if="imagesStyle !== IMAGES_SQUARE_MINIATURE">
              <div
                :class="setPlSaleOrientation"
                v-for="(label, index) in discountLabels"
                :key="`tl_img-${index}`"
                :style="{ background: label.color, color: label.textColor }"
              >
                {{
                `–${Math.floor(
                100 - (product.price / product.old_price) * 100
                )}%`
                }}
              </div>
            </template>

            <img
              :data-srcset="
                getImageUrl(product, IMAGE_TYPE_SPLASH) +
                ' 1x, ' +
                getImageUrl(product, IMAGE_TYPE_SPLASH_2X) +
                ' 2x'
              "
              @load="setHeight"
              alt=""
              class="placeholded-image"
              style="object-fit: cover"
              :data-url="getImageUrl(product, IMAGE_TYPE_SPLASH)"
              width="100%"
            />
          </div>
        </template>

        <!--endif-->

        <template v-if="priceOnPhoto">
          <!--if !is_stopped-->
          <div
            class="tl_price"
            :class="{ 'ios-font': $store.getters.checkIos }"
            v-if="
              !product.is_stopped && category.work_time.is_working_now !== false
            "
            v-html="
              $options.filters.toCurrency(product.price) +
              '<i>' +
              selectedQty +
              '</i>'
            "
          ></div>
          <!-- else -->
          <template v-else>
            <div
              class="tl_price"
              v-if="imagesStyle !== IMAGES_SQUARE_MINIATURE"
            >
              <template
                v-if="
                  category.work_time.is_working_now === false &&
                  category.work_time.to !== null &&
                  category.work_time.from !== null
                "
              >
                {{ category.work_time.from }} – {{ category.work_time.to }}
              </template>
              <template v-else>{{ text('product_not_available') }}</template>
            </div>
          </template>
          <!--endif-->
        </template>

        <!--        <template v-else>-->
        <div
          :class="setPlOrientation"
          v-if="imagesStyle !== IMAGES_SQUARE_MINIATURE"
        >
          <div class="pl_char">
            <div
              class="pl_action_inner"
              :class="{ 'ios-font': $store.getters.checkIos }"
              v-for="(label, index) in defaultLabels"
              :key="`pl_char-${index}`"
              :style="{ background: label.color, color: label.textColor }"
            >
              {{ label.name }}
            </div>
          </div>
        </div>
        <!--        </template>-->
      </div>
      <div class="tl_head">
        <div class="tl_name">
          {{ product.name }}
          <span>{{ product.qty }}&nbsp;{{ product.qty_unit }}</span>
        </div>

        <template
          v-if="
            showDescription &&
            product.images.length > 0 &&
            imagesStyle === IMAGES_SQUARE_MINIATURE
          "
        >
          <div
            class="tl_info"
            v-html="renderDescription(product.description)"
          ></div>
          <div class="fade" v-if="isLong(product.description)"></div>
        </template>

        <div
          v-if="!priceOnPhoto || product.images.length === 0"
          style="display: flex"
          :class="{ rtl_head: isRtl }"
        >
          <template v-if="product.show_price">
            <div
              v-if="product.old_price"
              class="tl_head_price bl_discounted_price"
              :class="{ 'rtl_head_price': isRtl, 'ios-font': $store.getters.checkIos }"
            >
              {{ $options.filters.toCurrency(product.old_price) }}
            </div>
            <div class="tl_head_price" :class="{ 'rtl_head_price': isRtl, 'ios-font': $store.getters.checkIos && !product.is_stopped }">
              <template v-if="product.is_stopped">
                {{ text('product_not_available') }}
              </template>
              <template v-else>
                <span>{{ selectedQty }}</span>
                {{ $options.filters.toCurrency(product.price) }}
              </template>
            </div>
          </template>
        </div>

        <div
          v-if="
            product.images.length !== 0 &&
            imagesStyle === IMAGES_SQUARE_MINIATURE
          "
          style="margin-top: 13px; display: flex"
        >
          <div style="width: 100%">
            <div
              class="pl_grid_three_column"
              :class="{ rtl_pl_grid_three_column: isRtl }"
              style="grid-template-columns: 1fr 1fr 1fr"
            >
              <div
                class="pl_action_inner"
                :class="{ 'ios-font': $store.getters.checkIos }"
                v-for="(label, index) in discountLabels"
                :key="`pl_action-${index}`"
                :style="{ background: label.color, color: label.textColor }"
              >
                {{
                `–${Math.floor(
                100 - (product.price / product.old_price) * 100
                )}%`
                }}
              </div>
              <div
                v-for="(label, index) in defaultLabels"
                :key="`pl_action_inner-${index}`"
                class="pl_action_inner"
                :class="getClassFromLabel(label)"
                :style="{ background: label.color, color: label.textColor }"
              >
                {{ label.name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <template
        v-if="
          showDescription &&
          (product.images.length === 0 ||
            imagesStyle !== IMAGES_SQUARE_MINIATURE)
        "
      >
        <div
          class="tl_info"
          v-html="renderDescription(product.description)"
        ></div>
        <div class="fade" v-if="isLong(product.description)"></div>
      </template>

      <div
        v-if="product.images.length === 0"
        style="margin-top: 13px; display: flex"
      >
        <div style="width: 100%">
          <div class="pl_char">
            <div class="pl_action" style="flex-direction: column">
              <div class="pl_action_row">
                <div
                  class="pl_action_inner pl_sale_num"
                  :class="{ 'ios-font': $store.getters.checkIos }"
                  v-for="(label, index) in discountLabels"
                  :key="`pl_sale-${index}`"
                  :style="{ background: label.color, color: label.textColor }"
                >
                  {{
                  `–${Math.round(
                  100 - (product.price / product.old_price) * 100
                  )}%`
                  }}
                </div>
                <div
                  class="pl_action_inner"
                  :class="{ 'ios-font': $store.getters.checkIos }"
                  v-for="(label, index) in defaultLabels"
                  :key="`pl_sale_num-${index}`"
                  :style="{ background: label.color, color: label.textColor }"
                >
                  {{ label.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
  const marked = require('marked')
  import {mapGetters} from 'vuex'
  import LazyLoadDirective from '../../directives/LazyLoadDirective'
  import {DISABLE_OVERLAY} from '@/store/actions.type'
  import {
    SET_CURRENT_PRODUCT,
    SET_MODAL,
    SET_SELECTED_PRODUCTS
  } from '@/store/mutations.type'

  const renderer = {
    code(code, infostring, escaped) {
      return '<p>' + code + '</p>'
    }
  }

  marked.use({renderer})

  export default {
    name: 'ProductItem',
    props: ['product', 'category'],
    directives: {
      lazyloadImage: LazyLoadDirective
    },
    data() {
      return {
        selected: false,
        selectedQty: 0,
        css_direction: 'ltr',

        IMAGE_TYPE_ORIGINAL: 0,
        IMAGE_TYPE_SPLASH: 1,
        IMAGE_TYPE_SPLASH_2X: 2,
        IMAGE_TYPE_LARGE: 3,

        LABEL_TYPE_DEFAULT: 0,
        LABEL_TYPE_DISCOUNT: 10
      }
    },
    computed: {
      isRtl() {
        return this.css_direction === 'rtl'
      },
      setPlSaleOrientation() {
        if (this.css_direction === 'rtl') {
          return 'rtl_pl_sale_num'
        } else {
          return 'pl_sale_num'
        }
      },
      setPlOrientation() {
        if (this.priceOnPhoto) {
          return 'topleft'
        } else if (!this.priceOnPhoto && this.css_direction === 'rtl') {
          return 'bottomleft'
        } else if (!this.priceOnPhoto) {
          return 'bottomright'
        }
      },
      discountLabels() {
        return this.product.old_price
          ? this.product.labels.filter(
            label => label.type === this.LABEL_TYPE_DISCOUNT
          )
          : []
      },
      defaultLabels() {
        return this.product.labels.filter(
          label => label.type === this.LABEL_TYPE_DEFAULT
        )
      },
      placeholderPadding() {
        let padding = ''

        if (
          this.imagesStyle === this.IMAGES_SQUARE_MINIATURE ||
          this.imagesStyle === this.IMAGES_SQUARE_LEFT ||
          this.imagesStyle === this.IMAGES_SQUARE_RIGHT
        ) {
          padding = '100%'
        }
        if (this.imagesStyle === this.IMAGES_WIDE) {
          padding = '56.25%'
        }

        return padding
      },

      oldPrice() {
        if (
          this.product.is_stopped ||
          this.category.work_time.is_working_now === false
        ) {
          return null
        }
        return this.$options.filters.toCurrency(this.product.old_price)
      },

      ...mapGetters([
        'priceOnPhoto',
        'basketPhoto',
        'showDescription',
        'imagesStyle',
        'IMAGES_SQUARE_MINIATURE',
        'IMAGES_SQUARE_LEFT',
        'IMAGES_SQUARE_RIGHT',
        'IMAGES_WIDE'
      ])
    },
    mounted() {
      this.css_direction = this.$store.getters.guardCssDirection
      this.ifSelected()

      this.$store.subscribe(mutation => {
        if (mutation.type === SET_SELECTED_PRODUCTS) {
          this.ifSelected()
        }
      })
      if (this.$store.getters.overlay === true) {
        this.$store.dispatch(DISABLE_OVERLAY)
      }
    },
    methods: {
      getClassFromLabel(label) {
        let labelClass = ''
        if (label.name.length > 30) {
          return 'pl_item__span3'
        } else if (label.name.length > 10) {
          return 'pl_item__span2'
        }
      },
      isLong(description) {
        if (
          this.imagesStyle === this.IMAGES_SQUARE_MINIATURE &&
          this.product.images.length > 0
        ) {
          return true
        }
        return description.length >= 110
      },
      renderDescription(description) {
        return marked(this.$options.filters.nl2br(description))
      },
      setHeight(event) {
        let image = event.target
        if (
          this.imagesStyle === this.IMAGES_SQUARE_MINIATURE ||
          this.imagesStyle === this.IMAGES_SQUARE_LEFT ||
          this.imagesStyle === this.IMAGES_SQUARE_RIGHT
        ) {
          image.height = image.clientWidth
        }
        if (this.imagesStyle === this.IMAGES_WIDE) {
          image.height = image.clientWidth * 0.5625
        }
      },

      getImageUrl(product, type) {
        let params = ''

        if (type === this.IMAGE_TYPE_ORIGINAL) {
          return product.images[0].original + params
        }
        if (type === this.IMAGE_TYPE_SPLASH) {
          return product.images[0].splash + params
        }
        if (type === this.IMAGE_TYPE_SPLASH_2X) {
          return product.images[0].splash_2x + params
        }
        if (type === this.IMAGE_TYPE_LARGE) {
          return product.images[0].large + params
        }
      },

      ifSelected() {
        this.selected = false
        this.selectedQty = 0
        this.$store.getters.selectedProducts.forEach(element => {
          if (element.id === this.product.id) {
            this.selected = true
            this.selectedQty += element.count
          }
        })
      },
      addToBasket(event) {
        if (
          this.product.is_stopped ||
          this.category.work_time.is_working_now === false
        ) {
          return
        }
        this.$store.commit(SET_CURRENT_PRODUCT, this.product)
        if (this.product.modifiers.length > 0) {
          this.$store.commit(SET_MODAL, {modal: 'options', status: true})
        } else {
          this.$store.commit(SET_MODAL, {modal: 'count', status: true})
        }
      }
    }
  }
</script>

<style scoped>
  .bottomright {
    position: absolute;
    right: 10px;
    bottom: 10px;
  }

  .bottomleft {
    position: absolute;
    left: 10px;
    bottom: 10px;
  }

  .topleft {
    position: absolute;
    left: 10px;
    top: 10px;
  }

  .topleft .pl_char {
    -webkit-box-pack: start;
    justify-content: flex-start;
  }

  div.placeholder {
    width: 100%;
    height: 0;
    background: #f7f7f7;
    position: relative;
  }

  img.placeholded-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .pl_action_row .pl_sale_num {
    position: inherit;
    height: 16px;
    line-height: 16px;
    width: 40px;
    text-align: center;
    border-radius: 2px;
    font-size: 9px;
    font-weight: bold;
  }

  .pl_sale_num,
  .rtl_pl_sale_num {
    font-size: 13px;
    color: #fff;
    font-weight: bold;
    position: absolute;
    z-index: 20;
    bottom: 10px;
    height: 21px;
    line-height: 21px;
    -webkit-border-radius: 3px;
    border-radius: 3px;
    background: #eb4253;
    width: 48px;
    text-align: center;
  }

  .pl_sale_num {
    left: 10px;
  }

  .rtl_pl_sale_num {
    direction: ltr;
    right: 10px;
  }

  .pl_char {
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 6px;
    grid-auto-flow: row dense;
  }

  .pl_grid_three_column {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-gap: 6px;
    grid-auto-flow: row dense;
  }

  .rtl_pl_grid_three_column {
    direction: ltr;
  }

  .pl_item__span2 {
    grid-column: auto/span 2;
  }

  .pl_item__span3 {
    grid-column: auto/span 3;
  }

  .pl_char_price {
    font-size: 16px;
    font-weight: 500;
    color: #1a1a1b;
    line-height: 100%;
  }

  .pl_action {
    display: flex;
    flex-direction: column;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
  }

  .pl_action .pl_action_row {
    display: flex;
    flex-direction: row;
  }

  .pl_action_inner {
    padding: 0 3px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    border-radius: 2px;
    font-size: 9px;
    font-weight: bold;
  }

  .pl_char_price span {
    display: block;
    font-size: 10px;
    line-height: 100%;
    color: #1a1a1b;
    opacity: 0.5;
    padding-bottom: 4px;
    text-decoration: line-through;
  }

  .pl_char_price span {
    display: block;
    font-size: 10px;
    line-height: 100%;
    color: #1a1a1b;
    opacity: 0.5;
    padding-bottom: 4px;
    text-decoration: line-through;
  }

  .rtl_head {
    justify-content: flex-end;
  }

  .tl_head_price + .tl_head_price {
    margin-left: 6px;
  }

  .rtl_head_price + .rtl_head_price {
    margin-right: 6px;
    margin-left: 0;
  }

  .product-image-multiple {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 26px;
    height: 26px;
    z-index: 10;
    background-size: cover;
    background-image: url("../../assets/img/ecommerce/multiple_photo.png")
  }

</style>
